<template>
  <div class="l-container Student_tutorsIndex">
    現在表示数 {{max}}

    <student-tutors-modal :modal="modal"></student-tutors-modal>

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span v-for="(list, index) in columns" :key="index">
      <template v-if="sortColumn === columns[index].code">
        {{ list.name }} : {{sortState}}
      </template>
    </span>

    <div style="display: flex">
      <h1 class="m-label m-label-custom" @click="switchColumns('columnsFlg')" v-bind:class="{ 'slideActive': columnsFlg }" v-ripple>項目</h1>
      <h1 class="m-label m-label-custom" @click="switchColumnBtn(1)" v-bind:class="{ 'slideActive': columnBtn === 1 }" v-ripple>探し中</h1>
      <h1 class="m-label m-label-custom" @click="switchColumnBtn(2)" v-bind:class="{ 'slideActive': columnBtn === 2 }" v-ripple>研修待ち</h1>
      <h1 class="m-label m-label-custom" @click="switchColumnBtn(3)" v-bind:class="{ 'slideActive': columnBtn === 3 }" v-ripple>紹介未</h1>
      <h1 class="m-label m-label-custom" @click="switchColumnBtn(4)" v-bind:class="{ 'slideActive': columnBtn === 4 }" v-ripple>初回日待ち</h1>
      <h1 class="m-label m-label-custom" @click="switchColumnBtn(5)" v-bind:class="{ 'slideActive': columnBtn === 5 }" v-ripple>未来探し</h1>
    </div>

    <template v-if="columnsFlg">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>
        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchV(index)" v-bind:class="{ 'active': columns[index].show }">{{ list.name }}</btn>
      </div>
    </template>

    <template v-if="columnBtn === 1">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="save1()">SAVE</btn>
        <btn class="m-btn--column" @click.native="resetBtn1()">RESET</btn>
        <btn class="m-btn--column" @click.native="allBtn1()">ALL</btn>
        <btn class="m-btn--column" @click.native="defBtn1()">DEFAULT</btn>
        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchVbtn1(index)" v-bind:class="{ 'active': columns[index].btn1Show }">{{ list.name }}</btn>
      </div>
    </template>

    <template v-if="columnBtn === 2">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="save2()">SAVE</btn>
        <btn class="m-btn--column" @click.native="resetBtn2()">RESET</btn>
        <btn class="m-btn--column" @click.native="allBtn2()">ALL</btn>
        <btn class="m-btn--column" @click.native="defBtn2()">DEFAULT</btn>
        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchVbtn2(index)" v-bind:class="{ 'active': columns[index].btn2Show }">{{ list.name }}</btn>
      </div>
    </template>

    <template v-if="columnBtn === 3">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="save3()">SAVE</btn>
        <btn class="m-btn--column" @click.native="resetBtn3()">RESET</btn>
        <btn class="m-btn--column" @click.native="allBtn3()">ALL</btn>
        <btn class="m-btn--column" @click.native="defBtn3()">DEFAULT</btn>
        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchVbtn3(index)" v-bind:class="{ 'active': columns[index].btn3Show }">{{ list.name }}</btn>
      </div>
    </template>

    <template v-if="columnBtn === 4">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="save4()">SAVE</btn>
        <btn class="m-btn--column" @click.native="resetBtn4()">RESET</btn>
        <btn class="m-btn--column" @click.native="allBtn4()">ALL</btn>
        <btn class="m-btn--column" @click.native="defBtn4()">DEFAULT</btn>
        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchVbtn4(index)" v-bind:class="{ 'active': columns[index].btn4Show }">{{ list.name }}</btn>
      </div>
    </template>

    <template v-if="columnBtn === 5">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="save5()">SAVE</btn>
        <btn class="m-btn--column" @click.native="resetBtn5()">RESET</btn>
        <btn class="m-btn--column" @click.native="allBtn5()">ALL</btn>
        <btn class="m-btn--column" @click.native="defBtn5()">DEFAULT</btn>
        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchVbtn5(index)" v-bind:class="{ 'active': columns[index].btn5Show }">{{ list.name }}</btn>
      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div style="display: flex; margin-top: 10px">
      <student-tutors-add :modal="modal" @set="setSelect"></student-tutors-add>
      <btn class="m-btn--column" @click.native="btn1">探し中</btn>
      <btn class="m-btn--column" @click.native="btn2">研修待ち</btn>
      <btn class="m-btn--column" @click.native="btn3">紹介未</btn>
      <btn class="m-btn--column" @click.native="btn4">初回日待ち</btn>
      <btn class="m-btn--column" @click.native="btn5">未来探し</btn>
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <template v-if="columns[0].show"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.state" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="state" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.matching_type" :options="matching_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.change_reason" :options="change_reason" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-1"><input v-model="search.filing_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show"><td-c class="sticky-1"><input v-model="search.elapsed" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[8].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.matching_month" :options="matching_month" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[9].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.seven_days_tel" :options="tel" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[10].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.ten_days_tel" :options="tel" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[11].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.fourteen_days_tel" :options="tel" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[12].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.charge_person" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[13].show"><td-c class="sticky-1"><input v-model="search.matching_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[14].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.decision_person" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[15].show"><td-c class="sticky-1"><input v-model="search.training_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.training_check" :options="zumi" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[17].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.document" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[18].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.document_sending_check" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.document_receipt_check" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show"><td-c class="sticky-1"><input v-model="search.first_day_limit" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[21].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.first_day_check" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[22].show"><td-c class="sticky-1"><input v-model="search.first_day" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.hold_person" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[24].show"><td-c class="sticky-1"><input v-model="search.family_tel_limit" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[25].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.family_pref" :options="orderedPrefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[26].show"><td-c class="sticky-1"><input v-model="search.family_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[27].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.student_state" :options="student_state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[28].show"><td-c class="sticky-1"><input v-model="search.student_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[29].show"><td-c class="sticky-1"><input v-model="search.student_kana" type="text" @keyup="searchTable()" v-focus></td-c></template>
          <template v-if="columns[30].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.student_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[31].show"><td-c class="sticky-1"><input v-model="search.tutor_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[32].show"><td-c class="sticky-1"><input v-model="search.tutor_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[33].show"><td-c class="sticky-1" style="background: #eee"></td-c></template>
          <template v-if="columns[34].show"><td-c class="sticky-1" style="background: #eee"></td-c></template>
          <template v-if="columns[35].show"><td-c class="sticky-1" style="background: #eee"></td-c></template>
          <template v-if="columns[36].show"><td-c class="sticky-1"><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[37].show"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <template v-if="columns[0].show"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_state" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="value" :options="state" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_matching_type" :options="matching_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[5].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_change_reason" :options="change_reason" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[6].show"><td-c class="sticky-2"><input v-model="search.not_filing_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[7].show"><td-c class="sticky-2"><input v-model="search.not_elapsed" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[8].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_matching_month" :options="matching_month" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[9].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_seven_days_tel" :options="tel" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[10].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_ten_days_tel" :options="tel" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[11].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_fourteen_days_tel" :options="tel" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[12].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_charge_person" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[13].show"><td-c class="sticky-2"><input v-model="search.not_matching_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[14].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_decision_person" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[15].show"><td-c class="sticky-2"><input v-model="search.not_training_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[16].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_training_check" :options="zumi" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[17].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_document" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[18].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_document_sending_check" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_document_receipt_check" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show"><td-c class="sticky-2"><input v-model="search.not_first_day_limit" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[21].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_first_day_check" :options="check" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[22].show"><td-c class="sticky-2"><input v-model="search.not_first_day" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[23].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_hold_person" :options="filteredUsers" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[24].show"><td-c class="sticky-2"><input v-model="search.not_family_tel_limit" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[25].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_family_pref" :options="orderedPrefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[26].show"><td-c class="sticky-2"><input v-model="search.not_family_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[27].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_student_state" :options="student_state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[28].show"><td-c class="sticky-2"><input v-model="search.not_student_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[29].show"><td-c class="sticky-2"><input v-model="search.not_student_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[30].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_student_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[31].show"><td-c class="sticky-2"><input v-model="search.not_tutor_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[32].show"><td-c class="sticky-2"><input v-model="search.not_tutor_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[33].show"><td-c class="sticky-2" style="background: #eee"></td-c></template>
          <template v-if="columns[34].show"><td-c class="sticky-2" style="background: #eee"></td-c></template>
          <template v-if="columns[35].show"><td-c class="sticky-2" style="background: #eee"></td-c></template>
          <template v-if="columns[36].show"><td-c class="sticky-2"><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="columns[37].show"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <!-- <tr&#45;c slot="tr&#45;th"> -->
        <!--   <th&#45;c v&#45;for="(list, index) in columns" :key="index" v&#45;if="columns[index].show" class="sticky&#45;3" @click.native='sort(columns[index].code)' v&#45;ripple v&#45;ripple style="min&#45;width: 100px">{{ list.name }}</th&#45;c> -->
        <!-- </tr&#45;c> -->

        <tr-c slot="tr-th">
          <template v-if="columns[0].show"><th-c class="sticky-3" @click.native='sort("id")' style="min-width: 50px">ID</th-c></template>
          <template v-if="columns[1].show"><th-c class="sticky-3" @click.native='sort("office_id")' style="min-width: 80px">営業所</th-c></template>
          <template v-if="columns[2].show"><th-c class="sticky-3" @click.native='sort("user_id")' style="min-width: 100px">登録者</th-c></template>
          <template v-if="columns[3].show"><th-c class="sticky-3" @click.native='sort("state")' style="min-width: 100px">状態</th-c></template>
          <template v-if="columns[4].show"><th-c class="sticky-3" @click.native='sort("matching_type")' style="min-width: 100px">種類</th-c></template>
          <template v-if="columns[5].show"><th-c class="sticky-3" @click.native='sort("change_reason")' style="min-width: 100px">チェンジ理由</th-c></template>
          <template v-if="columns[6].show"><th-c class="sticky-3" @click.native='sort("filing_date")' style="min-width: 80px">提出日</th-c></template>
          <template v-if="columns[7].show"><th-c class="sticky-3" @click.native='sort("elapsed")' style="min-width: 80px">経過日数</th-c></template>
          <template v-if="columns[8].show"><th-c class="sticky-3" @click.native='sort("matching_month")' style="min-width: 80px">探し月</th-c></template>
          <template v-if="columns[9].show"><th-c class="sticky-3" @click.native='sort("seven_days_tel")' style="min-width: 50px">7日</th-c></template>
          <template v-if="columns[10].show"><th-c class="sticky-3" @click.native='sort("ten_days_tel")' style="min-width: 50px">10日</th-c></template>
          <template v-if="columns[11].show"><th-c class="sticky-3" @click.native='sort("fourteen_days_tel")' style="min-width: 50px">14日</th-c></template>
          <template v-if="columns[12].show"><th-c class="sticky-3" @click.native='sort("charge_person")' style="min-width: 100px">探し担当</th-c></template>
          <template v-if="columns[13].show"><th-c class="sticky-3" @click.native='sort("matching_date")' style="min-width: 80px">決めた日</th-c></template>
          <template v-if="columns[14].show"><th-c class="sticky-3" @click.native='sort("decision_person")' style="min-width: 100px">決めた人</th-c></template>
          <template v-if="columns[15].show"><th-c class="sticky-3" @click.native='sort("training_date")' style="min-width: 50px">研修日</th-c></template>
          <template v-if="columns[16].show"><th-c class="sticky-3" @click.native='sort("training_check")' style="min-width: 50px">研修check</th-c></template>
          <template v-if="columns[17].show"><th-c class="sticky-3" @click.native='sort("document")' style="min-width: 50px">資料</th-c></template>
          <template v-if="columns[18].show"><th-c class="sticky-3" @click.native='sort("document_sending_check")' style="min-width: 50px">資料送付確認</th-c></template>
          <template v-if="columns[19].show"><th-c class="sticky-3" @click.native='sort("document_receipt_check")' style="min-width: 50px">資料受取確認</th-c></template>
          <template v-if="columns[20].show"><th-c class="sticky-3" @click.native='sort("first_day_limit")' style="min-width: 80px">初回日期限</th-c></template>
          <template v-if="columns[21].show"><th-c class="sticky-3" @click.native='sort("first_day_check")' style="min-width: 50px">初回</th-c></template>
          <template v-if="columns[22].show"><th-c class="sticky-3" @click.native='sort("first_day")' style="min-width: 80px">初回日</th-c></template>
          <template v-if="columns[23].show"><th-c class="sticky-3" @click.native='sort("hold_person")' style="min-width: 100px">持ってる人</th-c></template>
          <template v-if="columns[24].show"><th-c class="sticky-3" @click.native='sort("family_tel_limit")' style="min-width: 80px">家庭TEL期限</th-c></template>
          <template v-if="columns[25].show"><th-c class="sticky-3" @click.native='sort("family_pref")' style="min-width: 100px">都道府県</th-c></template>
          <template v-if="columns[26].show"><th-c class="sticky-3" @click.native='sort("family_address")' style="min-width: 200px">住所</th-c></template>
          <template v-if="columns[27].show"><th-c class="sticky-3" @click.native='sort("student_state")' style="min-width: 200px">生徒状態</th-c></template>
          <template v-if="columns[28].show"><th-c class="sticky-3" @click.native='sort("student_name")' style="min-width: 100px">生徒</th-c></template>
          <template v-if="columns[29].show"><th-c class="sticky-3" @click.native='sort("student_kana")' style="min-width: 100px">せいと</th-c></template>
          <template v-if="columns[30].show"><th-c class="sticky-3" @click.native='sort("student_grade")' style="min-width: 100px">生徒学年</th-c></template>
          <template v-if="columns[31].show"><th-c class="sticky-3" @click.native='sort("tutor_name")' style="min-width: 100px">先生</th-c></template>
          <template v-if="columns[32].show"><th-c class="sticky-3" @click.native='sort("tutor_kana")' style="min-width: 100px">せんせい</th-c></template>
          <template v-if="columns[33].show"><th-c class="sticky-3" @click.native='sort("keep1")' style="min-width: 100px">候補1</th-c></template>
          <template v-if="columns[34].show"><th-c class="sticky-3" @click.native='sort("keep2")' style="min-width: 100px">候補2</th-c></template>
          <template v-if="columns[35].show"><th-c class="sticky-3" @click.native='sort("keep3")' style="min-width: 100px">候補3</th-c></template>
          <template v-if="columns[36].show"><th-c class="sticky-3" @click.native='sort("note")' style="min-width: 200px">備考</th-c></template>
          <template v-if="columns[37].show"><th-c class="sticky-3" @click.native='sort("created_at")' style="min-width: 80px">作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="(list, index) in mapStudent_tutors" :key="index.id" @click.native="modalLink(list)" class="tr_hover">

          <template v-if="columns[0].show"><td-c>{{list.id}}</td-c></template>
          <template v-if="columns[1].show"><td-c>{{list.mapOffice_id}}</td-c></template>
          <template v-if="columns[2].show">
            <td-c v-if="list.user">{{list.user.user}}</td-c>
            <td-c v-else></td-c>
          </template>
          <template v-if="columns[3].show"><td-c>{{list.mapState}}</td-c></template>
          <template v-if="columns[4].show"><td-c>{{list.mapMatchingType}}</td-c></template>
          <template v-if="columns[5].show"><td-c>{{list.mapChangeReason}}</td-c></template>
          <template v-if="columns[6].show"><td-c>{{list.filing_date}}</td-c></template>
          <template v-if="columns[7].show"><td-c v-bind:class="{ 'orange': elapsed7(list.filing_date, list.state), 'red': elapsed10(list.filing_date, list.state) }">{{list.mapElapsed}}</td-c></template>
          <template v-if="columns[8].show"><td-c>{{list.matching_month}}</td-c></template>

          <template v-if="columns[9].show">
            <td-c v-if="list.seven_days_tel === 0" v-bind:class="{ 'red': limit(list.filing_date, 7, list.state) }"></td-c>
            <td-c v-if="list.seven_days_tel === 1">○</td-c>
            <td-c v-if="list.seven_days_tel === 2" v-bind:class="{ 'red': limit(list.filing_date, 7, list.state) }">留守</td-c>
            <td-c v-if="list.seven_days_tel === 3" v-bind:class="{ 'red': limit(list.filing_date, 7, list.state) }">TEL</td-c>
          </template>

          <template v-if="columns[10].show">
            <td-c v-if="list.ten_days_tel === 0" v-bind:class="{ 'red': limit(list.filing_date, 10, list.state) }"></td-c>
            <td-c v-if="list.ten_days_tel === 1">○</td-c>
            <td-c v-if="list.ten_days_tel === 2" v-bind:class="{ 'red': limit(list.filing_date, 10, list.state) }">留守</td-c>
            <td-c v-if="list.ten_days_tel === 3" v-bind:class="{ 'red': limit(list.filing_date, 10, list.state) }">TEL</td-c>
          </template>

          <template v-if="columns[11].show">
            <td-c v-if="list.fourteen_days_tel === 0" v-bind:class="{ 'red': limit(list.filing_date, 14, list.state) }"></td-c>
            <td-c v-if="list.fourteen_days_tel === 1">○</td-c>
            <td-c v-if="list.fourteen_days_tel === 2" v-bind:class="{ 'red': limit(list.filing_date, 14, list.state) }">留守</td-c>
            <td-c v-if="list.fourteen_days_tel === 3" v-bind:class="{ 'red': limit(list.filing_date, 14, list.state) }">TEL</td-c>
          </template>

          <template v-if="columns[12].show"><td-c>{{list.mapCharge_person}}</td-c></template>
          <template v-if="columns[13].show"><td-c>{{list.matching_date}}</td-c></template>
          <template v-if="columns[14].show"><td-c>{{list.mapDecision_person}}</td-c></template>
          <template v-if="columns[15].show"><td-c>{{list.training_date}}</td-c></template>

          <template v-if="columns[16].show">
            <td-c v-if="list.training_check === 0"></td-c>
            <td-c v-if="list.training_check === 1">済</td-c>
          </template>

          <template v-if="columns[17].show">
            <td-c v-if="list.document === 0"></td-c>
            <td-c v-if="list.document === 1">○</td-c>
          </template>

          <template v-if="columns[18].show">
            <td-c v-if="list.document_sending_check === 0"></td-c>
            <td-c v-if="list.document_sending_check === 1">○</td-c>
          </template>

          <template v-if="columns[19].show">
            <td-c v-if="list.document_receipt_check === 0"></td-c>
            <td-c v-if="list.document_receipt_check === 1">○</td-c>
          </template>

          <template v-if="columns[20].show"><td-c>{{list.first_day_limit}}</td-c></template>

          <template v-if="columns[21].show">
            <td-c v-if="list.first_day_check === 0"></td-c>
            <td-c v-if="list.first_day_check === 1">○</td-c>
          </template>

          <template v-if="columns[22].show"><td-c>{{list.first_day}}</td-c></template>
          <template v-if="columns[23].show"><td-c>{{list.mapHold_person}}</td-c></template>

          <template v-if="columns[24].show">
            <td-c v-bind:class="{ 'red': limitFamily(list.family_tel_limit, list.state) }">{{list.family_tel_limit}}</td-c>
          </template>

          <template v-if="columns[25].show"><td-c>{{list.mapFamilyPref}}</td-c></template>

          <template v-if="columns[26].show">
            <template v-if="list.student.family">
              <td-c>
                {{list.student.family.address1}} {{list.student.family.address2}}
              </td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[27].show">
            <template v-if="list.student">
              <td-c class="link" @click.native="linkStudent($event, list)">{{list.mapStudent_state}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[28].show">
            <template v-if="list.student">
              <td-c class="link" @click.native="linkStudent($event, list)">{{list.student.f_name}} {{list.student.l_name}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[29].show">
            <template v-if="list.student">
              <td-c class="link" @click.native="linkStudent($event, list)">{{list.student.f_name_kana}} {{list.student.l_name_kana}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[30].show">
            <template v-if="list.student">
              <td-c class="link" @click.native="linkStudent($event, list)">{{list.mapStudent_grade}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[31].show">
            <template v-if="list.tutor">
              <td-c class="link" @click.native="linkTutor($event, list)">{{list.tutor.f_name}} {{list.tutor.l_name}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[32].show">
            <template v-if="list.tutor">
              <td-c class="link" @click.native="linkTutor($event, list)">{{list.tutor.f_name_kana}} {{list.tutor.l_name_kana}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[33].show">
            <template v-if="list.keep_id1 > 0">
              <td-c class="link" @click.native="linkKeep1($event, list)">{{list.keep_f_name1}} {{list.keep_l_name1}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[34].show">
            <template v-if="list.keep_id2 > 0">
              <td-c class="link" @click.native="linkKeep2($event, list)">{{list.keep_f_name2}} {{list.keep_l_name2}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[35].show">
            <template v-if="list.keep_id3 > 0">
              <td-c class="link" @click.native="linkKeep3($event, list)">{{list.keep_f_name3}} {{list.keep_l_name3}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>

          <template v-if="columns[36].show"><td-c>{{list.note}}</td-c></template>
          <template v-if="columns[37].show"><td-c>{{list.created_at.substring(0, 10)}}</td-c></template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/student_tutors/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'student_tutor',
  pageNames: 'student_tutors'
}

let _ = window._
export default {
  props: {
  },
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  data () {
    return {
      modal: {
        obj: '',
        condition: false,
        list: '',
        stateSelect: [],
        matching_typeSelect: [],
        change_reasonSelect: [],
        telSelect: [],
        checkSelect: [],
        zumiSelect: [],
        matching_monthSelect: []
      },

      sortState: '降順',
      sortColumn: '',

      columnsFlg: false,
      columnBtn: '',

      columns: [
        {
          code: 'id',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: 'ID'
        },
        {
          code: 'office_id',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '営業所'
        },
        {
          code: 'user_id',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '登録者'
        },
        {
          code: 'state',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '状態'
        },
        {
          code: 'matching_type',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '種類'
        },
        {
          code: 'change_reason',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: 'チェンジ理由'
        },
        {
          code: 'filing_date',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '提出日'
        },
        {
          code: 'elapsed',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '経過日数'
        },
        {
          code: 'matching_month',
          show: false,
          def: false,
          btn1Show: true,
          btn1Def: true,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '探し月'
        },
        {
          code: 'seven_days_tel',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '7日'
        },
        {
          code: 'ten_days_tel',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '10日'
        },
        {
          code: 'fourteen_days_tel',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '14日'
        },
        {
          code: 'charge_person',
          show: false,
          def: false,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '探し担当'
        },
        {
          code: 'matching_date',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '決めた日'
        },
        {
          code: 'decision_person',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '決めた人'
        },
        {
          code: 'training_date',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '研修日'
        },
        {
          code: 'training_check',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '研修check'
        },
        {
          code: 'document',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '資料'
        },
        {
          code: 'document_sending_check',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '資料送付確認'
        },
        {
          code: 'document_receipt_check',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '資料受取確認'
        },
        {
          code: 'first_day_limit',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: true,
          btn4Def: true,
          btn5Show: false,
          btn5Def: false,
          name: '初回日期限'
        },
        {
          code: 'first_day_check',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: true,
          btn4Def: true,
          btn5Show: false,
          btn5Def: false,
          name: '初回'
        },
        {
          code: 'first_day',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '初回日'
        },
        {
          code: 'hold_person',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '持ってる人'
        },
        {
          code: 'family_tel_limit',
          show: false,
          def: false,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: false,
          btn4Def: false,
          btn5Show: true,
          btn5Def: true,
          name: '家庭TEL期限'
        },
        {
          code: 'family_pref',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: true,
          btn4Def: true,
          btn5Show: true,
          btn5Def: true,
          name: '都道府県'
        },
        {
          code: 'family_address',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: true,
          btn4Def: true,
          btn5Show: true,
          btn5Def: true,
          name: '住所'
        },
        {
          code: 'student_state',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '生徒状態'
        },
        {
          code: 'student_name',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: true,
          btn4Def: true,
          btn5Show: true,
          btn5Def: true,
          name: '生徒'
        },
        {
          code: 'student_kana',
          show: true,
          def: true,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: 'せいと'
        },
        {
          code: 'student_grade',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: true,
          btn4Def: true,
          btn5Show: true,
          btn5Def: true,
          name: '生徒学年'
        },
        {
          code: 'tutor_name',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: true,
          btn4Def: true,
          btn5Show: true,
          btn5Def: true,
          name: '先生'
        },
        {
          code: 'tutor_kana',
          show: true,
          def: true,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: 'せんせい'
        },
        {
          code: 'keep1',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '候補1'
        },
        {
          code: 'keep2',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '候補2'
        },
        {
          code: 'keep3',
          show: true,
          def: true,
          btn1Show: true,
          btn1Def: true,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '候補3'
        },
        {
          code: 'note',
          show: false,
          def: false,
          btn1Show: true,
          btn1Def: true,
          btn2Show: true,
          btn2Def: true,
          btn3Show: true,
          btn3Def: true,
          btn4Show: true,
          btn4Def: true,
          btn5Show: true,
          btn5Def: true,
          name: '備考'
        },
        {
          code: 'created_at',
          show: false,
          def: false,
          btn1Show: false,
          btn1Def: false,
          btn2Show: false,
          btn2Def: false,
          btn3Show: false,
          btn3Def: false,
          btn4Show: false,
          btn4Def: false,
          btn5Show: false,
          btn5Def: false,
          name: '作成日'
        }
      ],

      search: {
        id: '',
        office_id: '',
        user_id: '',
        state: '1 2 3 4',
        matching_type: '',
        change_reason: '',
        filing_date: '',
        elapsed: '',
        matching_month: '',
        seven_days_tel: '',
        ten_days_tel: '',
        fourteen_days_tel: '',
        charge_person: '',
        matching_date: '',
        decision_person: '',
        training_date: '',
        training_check: '',
        document: '',
        document_sending_check: '',
        document_receipt_check: '',
        first_day_limit: '',
        first_day_check: '',
        first_day: '',
        hold_person: '',
        family_tel_limit: '',
        family_pref: '',
        family_address: '',
        student_state: '',
        student_name: '',
        student_kana: '',
        student_grade: '',
        tutor_name: '',
        tutor_kana: '',
        keep1: '',
        keep2: '',
        keep3: '',
        note: '',
        created_at: '',

        not_id: '',
        not_office_id: '',
        not_user_id: '',
        not_state: '',
        not_matching_type: '',
        not_change_reason: '',
        not_filing_date: '',
        not_elapsed: '',
        not_matching_month: '',
        not_seven_days_tel: '',
        not_ten_days_tel: '',
        not_fourteen_days_tel: '',
        not_charge_person: '',
        not_matching_date: '',
        not_decision_person: '',
        not_training_date: '',
        not_training_check: '',
        not_document: '',
        not_document_sending_check: '',
        not_document_receipt_check: '',
        not_first_day_limit: '',
        not_first_day_check: '',
        not_first_day: '',
        not_hold_person: '',
        not_family_tel_limit: '',
        not_family_pref: '',
        not_family_address: '',
        not_student_state: '',
        not_student_name: '',
        not_student_kana: '',
        not_student_grade: '',
        not_tutor_name: '',
        not_tutor_kana: '',
        not_keep1: '',
        not_keep2: '',
        not_keep3: '',
        not_note: '',
        not_created_at: ''
      },

      watch: {
        office_id: '',
        user_id: '',
        state: [],
        matching_type: '',
        change_reason: '',
        matching_month: '',
        seven_days_tel: '',
        ten_days_tel: '',
        fourteen_days_tel: '',
        charge_person: '',
        decision_person: '',
        training_check: '',
        document: '',
        document_sending_check: '',
        document_receipt_check: '',
        first_day_check: '',
        hold_person: '',
        family_pref: '',
        student_state: '',
        student_grade: '',

        not_office_id: '',
        not_user_id: '',
        not_state: [],
        not_matching_type: '',
        not_change_reason: '',
        not_matching_month: '',
        not_seven_days_tel: '',
        not_ten_days_tel: '',
        not_fourteen_days_tel: '',
        not_charge_person: '',
        not_decision_person: '',
        not_training_check: '',
        not_document: '',
        not_document_sending_check: '',
        not_document_receipt_check: '',
        not_first_day_check: '',
        not_hold_person: '',
        not_family_pref: '',
        not_student_state: '',
        not_student_grade: ''
      }
    }
  },
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    state () {
      return this.$store.getters['student_tutors/state']
    },

    matching_type () {
      return this.$store.getters['student_tutors/matching_type']
    },

    change_reason () {
      return this.$store.getters['student_tutors/change_reason']
    },

    tel () {
      return this.$store.getters['student_tutors/tel']
    },

    check () {
      return this.$store.getters['student_tutors/check']
    },

    zumi () {
      return this.$store.getters['student_tutors/zumi']
    },

    student_state () {
      return this.$store.getters['students/state']
    },

    grade () {
      return this.$store.getters['student_tutors/grade']
    },

    matching_month () {
      return this.$store.getters['student_tutors/matching_month']
    },

    prefs () {
      return this.$store.getters.prefs
    },

    orderedPrefs () {
      return _.orderBy(this.prefs, 'id')
    },

    student_tutors () {
      return this.$store.getters.student_tutors
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    filteredUsers () {
      let self = this
      if (self.user.office_id === 1) {
        return self.users.filter(user => {
          return user.office_id === 1 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 2) {
        return self.users.filter(user => {
          return user.office_id === 2 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 3) {
        return self.users.filter(user => {
          return user.office_id === 3 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 4) {
        return self.users.filter(user => {
          return user.office_id === 4 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 5) {
        return self.users.filter(user => {
          return user.office_id === 5 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 6) {
        return self.users.filter(user => {
          return user.office_id === 6 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 7) {
        return self.users.filter(user => {
          return user.office_id === 7 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 8) {
        return self.users.filter(user => {
          return user.office_id === 8 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 9) {
        return self.users.filter(user => {
          return user.office_id === 9 && user.hide_flag !== 1
        })
      } else if (self.user.office_id === 10) {
        return self.users.filter(user => {
          return user.office_id === 10 && user.hide_flag !== 1
        })
      } else {
        return self.users.filter(user => {
          return user.hide_flag !== 1
        })
      }
    },

    offices () {
      return this.$store.getters.offices
    },

    orderedStudent_tutorsDefault () {
      return _.orderBy(this.student_tutors, 'state')
    },

    orderedStudent_tutors () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.orderedStudent_tutorsDefault, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.orderedStudent_tutorsDefault, this.sortColumn)
      }
    },

    mapStudent_tutors () {
      let self = this
      return self.orderedStudent_tutors.map(student_tutor => {
        student_tutor.mapOffice_id = self.calcArry(student_tutor.office_id, 'offices')
        student_tutor.mapState = self.calcSelect(student_tutor.state, 'state')
        student_tutor.mapMatchingType = self.calcSelect(student_tutor.matching_type, 'matching_type')
        student_tutor.mapChangeReason = self.calcSelect(student_tutor.change_reason, 'change_reason')
        // student_tutor.mapSevenDaysTel = self.calcSelect(student_tutor.seven_days_tel, 'tel')
        // student_tutor.mapTenDaysTel = self.calcSelect(student_tutor.ten_days_tel, 'tel')
        // student_tutor.mapFourteenDaysTel = self.calcSelect(student_tutor.fourteen_days_tel, 'tel')
        student_tutor.mapElapsed = self.calcElapsed(student_tutor.filing_date)
        student_tutor.mapCharge_person = self.calcUser(student_tutor.charge_person)
        student_tutor.mapDecision_person = self.calcUser(student_tutor.decision_person)
        student_tutor.mapHold_person = self.calcUser(student_tutor.hold_person)
        student_tutor.mapFamilyPref = self.calcArry(student_tutor.student.family.pref, 'prefs')
        student_tutor.mapStudent_state = self.calcSelect(student_tutor.student.state, 'student_state')
        student_tutor.mapStudent_grade = self.calcGrade(student_tutor.student.birthday, student_tutor.student.grade_flag)
        return student_tutor
      })
    }
  },
  watch: {
    'watch.state': function (now, old) {
      if (now) {
        this.search.state = ''
        for (let i = 0; i < now.length; i++) {
          this.search.state += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_state += now[i].value + ' '
        }
        this.searchTable()
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    // 'watch.state': function (now, old) {
    //   if (now) {
    //     this.search.state = now.value
    //   } else {
    //     this.search.state = ''
    //   }
    // },

    // 'watch.not_state': function (now, old) {
    //   if (now) {
    //     this.search.not_state = now.value
    //   } else {
    //     this.search.not_state = ''
    //   }
    // },

    'watch.matching_type': function (now, old) {
      if (now) {
        this.search.matching_type = now.value
      } else {
        this.search.matching_type = ''
      }
    },

    'watch.not_matching_type': function (now, old) {
      if (now) {
        this.search.not_matching_type = now.value
      } else {
        this.search.not_matching_type = ''
      }
    },

    'watch.change_reason': function (now, old) {
      if (now) {
        this.search.change_reason = now.value
      } else {
        this.search.change_reason = ''
      }
    },

    'watch.not_change_reason': function (now, old) {
      if (now) {
        this.search.not_change_reason = now.value
      } else {
        this.search.not_change_reason = ''
      }
    },

    'watch.matching_month': function (now, old) {
      if (now) {
        this.search.matching_month = now.value
      } else {
        this.search.matching_month = ''
      }
    },

    'watch.not_matching_month': function (now, old) {
      if (now) {
        this.search.not_matching_month = now.value
      } else {
        this.search.not_matching_month = ''
      }
    },

    'watch.seven_days_tel': function (now, old) {
      if (now) {
        this.search.seven_days_tel = now.value
      } else {
        this.search.seven_days_tel = ''
      }
    },

    'watch.not_seven_days_tel': function (now, old) {
      if (now) {
        this.search.not_seven_days_tel = now.value
      } else {
        this.search.not_seven_days_tel = ''
      }
    },

    'watch.ten_days_tel': function (now, old) {
      if (now) {
        this.search.ten_days_tel = now.value
      } else {
        this.search.ten_days_tel = ''
      }
    },

    'watch.not_ten_days_tel': function (now, old) {
      if (now) {
        this.search.not_ten_days_tel = now.value
      } else {
        this.search.not_ten_days_tel = ''
      }
    },

    'watch.fourteen_days_tel': function (now, old) {
      if (now) {
        this.search.fourteen_days_tel = now.value
      } else {
        this.search.fourteen_days_tel = ''
      }
    },

    'watch.not_fourteen_days_tel': function (now, old) {
      if (now) {
        this.search.not_fourteen_days_tel = now.value
      } else {
        this.search.not_fourteen_days_tel = ''
      }
    },

    'watch.charge_person': function (now, old) {
      if (now) {
        this.search.charge_person = now.id
      } else {
        this.search.charge_person = ''
      }
    },

    'watch.not_charge_person': function (now, old) {
      if (now) {
        this.search.not_charge_person = now.id
      } else {
        this.search.not_charge_person = ''
      }
    },

    'watch.decision_person': function (now, old) {
      if (now) {
        this.search.decision_person = now.id
      } else {
        this.search.decision_person = ''
      }
    },

    'watch.not_decision_person': function (now, old) {
      if (now) {
        this.search.not_decision_person = now.id
      } else {
        this.search.not_decision_person = ''
      }
    },

    'watch.training_check': function (now, old) {
      if (now) {
        this.search.training_check = now.value
      } else {
        this.search.training_check = ''
      }
    },

    'watch.not_training_check': function (now, old) {
      if (now) {
        this.search.not_training_check = now.value
      } else {
        this.search.not_training_check = ''
      }
    },

    'watch.document': function (now, old) {
      if (now) {
        this.search.document = now.value
      } else {
        this.search.document = ''
      }
    },

    'watch.not_document': function (now, old) {
      if (now) {
        this.search.not_document = now.value
      } else {
        this.search.not_document = ''
      }
    },

    'watch.document_sending_check': function (now, old) {
      if (now) {
        this.search.document_sending_check = now.value
      } else {
        this.search.document_sending_check = ''
      }
    },

    'watch.not_document_sending_check': function (now, old) {
      if (now) {
        this.search.not_document_sending_check = now.value
      } else {
        this.search.not_document_sending_check = ''
      }
    },

    'watch.document_receipt_check': function (now, old) {
      if (now) {
        this.search.document_receipt_check = now.value
      } else {
        this.search.document_receipt_check = ''
      }
    },

    'watch.not_document_receipt_check': function (now, old) {
      if (now) {
        this.search.not_document_receipt_check = now.value
      } else {
        this.search.not_document_receipt_check = ''
      }
    },

    'watch.first_day_check': function (now, old) {
      if (now) {
        this.search.first_day_check = now.value
      } else {
        this.search.first_day_check = ''
      }
    },

    'watch.not_first_day_check': function (now, old) {
      if (now) {
        this.search.not_first_day_check = now.value
      } else {
        this.search.not_first_day_check = ''
      }
    },

    'watch.hold_person': function (now, old) {
      if (now) {
        this.search.hold_person = now.id
      } else {
        this.search.hold_person = ''
      }
    },

    'watch.not_hold_person': function (now, old) {
      if (now) {
        this.search.not_hold_person = now.id
      } else {
        this.search.not_hold_person = ''
      }
    },

    'watch.family_pref': function (now, old) {
      if (now) {
        this.search.family_pref = now.id
      } else {
        this.search.family_pref = ''
      }
    },

    'watch.not_family_pref': function (now, old) {
      if (now) {
        this.search.not_family_pref = now.id
      } else {
        this.search.not_family_pref = ''
      }
    },

    'watch.student_state': function (now, old) {
      if (now) {
        this.search.student_state = now.value
      } else {
        this.search.student_state = ''
      }
    },

    'watch.not_student_state': function (now, old) {
      if (now) {
        this.search.not_student_state = now.value
      } else {
        this.search.not_student_state = ''
      }
    },

    'watch.student_grade': function (now, old) {
      if (now) {
        this.search.student_grade = now.value
      } else {
        this.search.student_grade = ''
      }
    },

    'watch.not_student_grade': function (now, old) {
      if (now) {
        this.search.not_student_grade = now.value
      } else {
        this.search.not_student_grade = ''
      }
    }
  },
  methods: {
    save1 () {
      let arr = []
      let obj = {}

      for (let i = 0; i < this.columns.length; i++) {
        const btn1 = 'btn1_' + this.columns[i].code
        obj[btn1] = this.columns[i].btn1Show
      }

      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('Student_tutorsSearchBtn1', setjson)
    },

    save2 () {
      let arr = []
      let obj = {}

      for (let i = 0; i < this.columns.length; i++) {
        const btn2 = 'btn2_' + this.columns[i].code
        obj[btn2] = this.columns[i].btn2Show
      }

      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('Student_tutorsSearchBtn2', setjson)
    },

    save3 () {
      let arr = []
      let obj = {}

      for (let i = 0; i < this.columns.length; i++) {
        const btn3 = 'btn3_' + this.columns[i].code
        obj[btn3] = this.columns[i].btn3Show
      }

      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('Student_tutorsSearchBtn3', setjson)
    },

    save4 () {
      let arr = []
      let obj = {}

      for (let i = 0; i < this.columns.length; i++) {
        const btn4 = 'btn4_' + this.columns[i].code
        obj[btn4] = this.columns[i].btn4Show
      }

      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('Student_tutorsSearchBtn4', setjson)
    },

    save5 () {
      let arr = []
      let obj = {}

      for (let i = 0; i < this.columns.length; i++) {
        const btn5 = 'btn5_' + this.columns[i].code
        obj[btn5] = this.columns[i].btn5Show
      }

      arr.push(obj)
      let setjson = JSON.stringify(obj)
      localStorage.setItem('Student_tutorsSearchBtn5', setjson)
    },

    calcGrade (birthday, grade_flag) {
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(grade_flag)

      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else {
        grade = ''
      }
      return grade
    },

    limit (filing_date, number, state) {
      if (moment(filing_date).add(number, 'days') < new Date() && state !== 5) {
        return true
      }
    },

    limitFamily (family_tel_limit, state) {
      if (moment(family_tel_limit) < new Date() && family_tel_limit !== '0001-01-01' && state !== 5) {
        return true
      }
    },

    elapsed7 (filing_date, state) {
      if (moment(filing_date).add(7, 'days') < new Date() && moment(filing_date).add(10, 'days') > new Date() && state !== 5) {
        return true
      }
    },

    elapsed10 (filing_date, state) {
      if (moment(filing_date).add(10, 'days') < new Date() && state !== 5) {
        return true
      }
    },

    calcElapsed (filing_date) {
      var n = Date.parse(filing_date)
      var m = new Date()
      var x = (m - n) / 1000 / 60 / 60 / 24
      x = Math.floor(x)
      return x
    },

    calcUser (val) {
      if (val) {
        return this.users.filter(item => {
          return item.id === val
        })[0].user
      } else {
        return
      }
    },

    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return
      }
    },

    btn1 () {
      this.resetSearch()

      this.search.matching_month = '=='

      this.watch.state = []
      this.watch.state.push(
        this.state.filter(state => {
          return state.value === 1
        })[0]
      )

      let getjson = localStorage.getItem('Student_tutorsSearchBtn1')
      let obj = JSON.parse(getjson)

      for (let i = 0; i < this.columns.length; i++) {
        const btn1 = 'btn1_' + this.columns[i].code
        this.columns[i].show = obj[btn1]
      }
    },

    btn2 () {
      this.resetSearch()
      this.watch.state = []
      this.watch.state.push(
        this.state.filter(state => {
          return state.value === 2
        })[0]
      )

      let getjson = localStorage.getItem('Student_tutorsSearchBtn2')
      let obj = JSON.parse(getjson)

      for (let i = 0; i < this.columns.length; i++) {
        const btn2 = 'btn2_' + this.columns[i].code
        this.columns[i].show = obj[btn2]
      }
    },

    btn3 () {
      this.resetSearch()
      this.watch.state = []
      this.watch.state.push(
        this.state.filter(state => {
          return state.value === 3
        })[0]
      )

      let getjson = localStorage.getItem('Student_tutorsSearchBtn3')
      let obj = JSON.parse(getjson)

      for (let i = 0; i < this.columns.length; i++) {
        const btn3 = 'btn3_' + this.columns[i].code
        this.columns[i].show = obj[btn3]
      }
    },

    btn4 () {
      this.resetSearch()
      this.watch.state = []
      this.watch.state.push(
        this.state.filter(state => {
          return state.value === 4
        })[0]
      )

      let getjson = localStorage.getItem('Student_tutorsSearchBtn4')
      let obj = JSON.parse(getjson)

      for (let i = 0; i < this.columns.length; i++) {
        const btn4 = 'btn4_' + this.columns[i].code
        this.columns[i].show = obj[btn4]
      }
    },

    btn5 () {
      this.resetSearch()

      // this.watch.not_matching_month = this.matching_month.filter(matching_month => {
      //   return matching_month.value === ''
      // })[0]
      // 上記の検索は今のところできない設定なので裏でsearch.matching_monthに==とりあえずいれる
      this.search.not_matching_month = '=='

      this.watch.state = []

      this.searchTable()

      let getjson = localStorage.getItem('Student_tutorsSearchBtn5')
      let obj = JSON.parse(getjson)

      for (let i = 0; i < this.columns.length; i++) {
        const btn5 = 'btn5_' + this.columns[i].code
        this.columns[i].show = obj[btn5]
      }
    },

    setSelect () {
      this.modal.obj = this.obj
      this.modal.stateSelect = this.state
      this.modal.matching_typeSelect = this.matching_type
      this.modal.change_reasonSelect = this.change_reason
      this.modal.telSelect = this.tel
      this.modal.checkSelect = this.check
      this.modal.zumiSelect = this.zumi
      this.modal.matching_monthSelect = this.matching_month
    },

    modalLink (list) {
      this.modal.condition = !this.modal.condition
      this.modal.obj = this.obj
      this.modal.list = list
      this.modal.stateSelect = this.state
      this.modal.matching_typeSelect = this.matching_type
      this.modal.change_reasonSelect = this.change_reason
      this.modal.telSelect = this.tel
      this.modal.checkSelect = this.check
      this.modal.zumiSelect = this.zumi
      this.modal.matching_monthSelect = this.matching_month
    },
    linkStudent (event, list) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'studentindex', params: { id: list.student.id }}); window.open(routeData.href, '_blank')
      } else {
        const arr = [
          'id',
          'office_id',
          'user_id',
          'state',
          'f_name',
          'l_name',
          'f_name_kana',
          'l_name_kana',
          'gender',
          'birthday',
          'age',
          'school_type',
          'school_name',
          'guidance_detail',
          'takeover_time',
          'priority',
          'old_grade',
          'grade',
          'grade_flag',
          'service_period_start',
          'service_period_end',
          'inheritance_result',
          'next_contact_date',
          'note',
          'created_at'
        ]
        arr.forEach((item) => {
          this.$store.state.item.student[item] = list.student[item]
        })
        this.$router.push({name: 'studentindex', params: { id: list.student.id }})
      }
    },

    linkTutor (event, list) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'tutorindex', params: { id: list.tutor.id }}); window.open(routeData.href, '_blank')
      } else {
        const arr = [
          'id',
          'user_id',
          'state',
          'registration_date',
          'name',
          'kana',
          'gender',
          'birthday',
          'zip',
          'pref',
          'address',
          'tel1',
          'tel2',
          'mail1',
          'mail2',
          'home_zip',
          'home_pref',
          'home_address',
          'home_tel',
          'school_name',
          'school_stage',
          'department',
          'old_grade',
          'grade',
          'grade_flag',
          'department_type',
          'club',
          'transportation_car',
          'transportation_bike',
          'transportation_scooters',
          'transportation_bicycle',
          'transportation_train',
          'transportation_none',
          'nearest_station',
          'high_school_name',
          'high_school_club',
          'exam_s',
          'exam_c',
          'exam_k',
          'exam_d',
          'experience_tutor',
          'experience_tutor_note',
          'experience_cram',
          'experience_cram_note',
          'experience_none',
          'channel_id',
          'medium_note',
          'published',
          'information',
          'impression',
          'impression_note',
          'training',
          'training_note',
          'ssk',
          'note',
          'created_at'
        ]
        arr.forEach((item) => {
          this.$store.state.item.tutor[item] = list.tutor[item]
        })
        this.$router.push({name: 'tutorindex', params: { id: list.tutor.id }})
      }
    },

    linkKeep1 (event, list) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'tutorindex', params: { id: list.keep_id1 }}); window.open(routeData.href, '_blank')
      } else {
        this.$router.push({name: 'tutorindex', params: { id: list.keep_id1 }})
      }
    },

    linkKeep2 (event, list) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'tutorindex', params: { id: list.keep_id2 }}); window.open(routeData.href, '_blank')
      } else {
        this.$router.push({name: 'tutorindex', params: { id: list.keep_id2 }})
      }
    },

    linkKeep3 (event, list) {
      if (event.metaKey || event.ctrlKey) {
        let routeData = this.$router.resolve({name: 'tutorindex', params: { id: list.keep_id3 }}); window.open(routeData.href, '_blank')
      } else {
        this.$router.push({name: 'tutorindex', params: { id: list.keep_id3 }})
      }
    },

    switchColumns (col) {
      this.columnBtn = ''
      this[col] = !this[col]
    },

    switchColumnBtn (col) {
      this.columnsFlg = false
      this.columnBtn = col
    },

    switchV (col) {
      this.columns[col].show = !this.columns[col].show
    },

    switchVbtn1 (col) {
      this.columns[col].btn1Show = !this.columns[col].btn1Show
    },

    switchVbtn2 (col) {
      this.columns[col].btn2Show = !this.columns[col].btn2Show
    },

    switchVbtn3 (col) {
      this.columns[col].btn3Show = !this.columns[col].btn3Show
    },

    switchVbtn4 (col) {
      this.columns[col].btn4Show = !this.columns[col].btn4Show
    },

    switchVbtn5 (col) {
      this.columns[col].btn5Show = !this.columns[col].btn5Show
    },

    reset () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = false
      }
    },

    resetBtn1 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn1Show = false
      }
    },

    resetBtn2 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn2Show = false
      }
    },

    resetBtn3 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn3Show = false
      }
    },

    resetBtn4 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn4Show = false
      }
    },

    resetBtn5 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn5Show = false
      }
    },

    all () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = true
      }
    },

    allBtn1 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn1Show = true
      }
    },

    allBtn2 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn2Show = true
      }
    },

    allBtn3 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn3Show = true
      }
    },

    allBtn4 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn4Show = true
      }
    },

    allBtn5 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn5Show = true
      }
    },

    def () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = this.columns[i].def
      }
    },

    defBtn1 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn1Show = this.columns[i].btn1Def
      }
    },

    defBtn2 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn2Show = this.columns[i].btn2Def
      }
    },

    defBtn3 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn3Show = this.columns[i].btn3Def
      }
    },

    defBtn4 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn4Show = this.columns[i].btn4Def
      }
    },

    defBtn5 () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].btn5Show = this.columns[i].btn5Def
      }
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.watch.office_id = 0
      // this.watch.state = []
      this.watch.state = [
        { name: '探し中', value: 1 },
        { name: '研修待ち', value: 2 },
        { name: '紹介待ち', value: 3 },
        { name: '初回日待ち', value: 4 }
      ]
      this.watch.matching_type = 0
      this.watch.change_reason = 0
      this.search.filing_date = ''
      this.search.elapsed = ''
      this.search.matching_month = ''
      this.watch.seven_days_tel = 0
      this.watch.ten_days_tel = 0
      this.watch.fourteen_days_tel = 0
      this.watch.charge_person = 0
      this.search.matching_date = ''
      this.watch.decision_person = 0
      this.search.training_date = ''
      this.watch.training_check = 0
      this.watch.document = 0
      this.watch.document_sending_check = 0
      this.watch.document_receipt_check = 0
      this.search.first_day_limit = ''
      this.watch.first_day_check = 0
      this.search.first_day = ''
      this.watch.hold_person = 0
      this.search.family_tel_limit = ''
      this.watch.family_pref = 0
      this.search.family_address = ''
      this.watch.student_state = 0
      this.search.student_name = ''
      this.search.student_kana = ''
      this.watch.student_grade = ''
      this.search.tutor_name = ''
      this.search.tutor_kana = ''
      this.search.keep1 = ''
      this.search.keep2 = ''
      this.search.keep3 = ''
      this.search.note = ''

      this.watch.not_office_id = 0
      this.watch.not_state = []
      this.watch.not_matching_type = 0
      this.watch.not_change_reason = 0
      this.search.not_filing_date = ''
      this.search.not_elapsed = ''
      this.search.not_matching_month = ''
      this.watch.not_seven_days_tel = 0
      this.watch.not_ten_days_tel = 0
      this.watch.not_fourteen_days_tel = 0
      this.watch.not_charge_person = 0
      this.search.not_matching_date = ''
      this.watch.not_decision_person = 0
      this.search.not_training_date = ''
      this.watch.not_training_check = 0
      this.watch.not_document = 0
      this.watch.not_document_sending_check = 0
      this.watch.not_document_receipt_check = 0
      this.search.not_first_day_limit = ''
      this.watch.not_first_day_check = 0
      this.search.not_first_day = ''
      this.watch.not_hold_person = 0
      this.search.not_family_tel_limit = ''
      this.watch.not_family_pref = 0
      this.search.not_family_address = ''
      this.watch.not_student_state = 0
      this.search.not_student_name = ''
      this.search.not_student_kana = ''
      this.watch.not_student_grade = ''
      this.search.not_tutor_name = ''
      this.search.not_tutor_kana = ''
      this.search.not_keep1 = ''
      this.search.not_keep2 = ''
      this.search.not_keep3 = ''
      this.search.not_note = ''

      this.searchTable()
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.btn0()
      vm.searchTable()

      // alert('get')
      let getjson = localStorage.getItem('Student_tutorsSearch')
      let obj = JSON.parse(getjson)
      // vm.watch.office_id = obj['office_id']
      vm.watch.state = [
        { name: '探し中', value: 1 },
        { name: '研修待ち', value: 2 },
        { name: '紹介待ち', value: 3 },
        { name: '初回日待ち', value: 4 }
      ]

      for (let i = 0; i < vm.columns.length; i++) {
        const column = 'column_' + vm.columns[i].code
        vm.columns[i].show = obj[column]
      }

      if (localStorage.getItem('Student_tutorsSearchBtn1')) {
        let getjson1 = localStorage.getItem('Student_tutorsSearchBtn1')
        let obj1 = JSON.parse(getjson1)

        for (let i = 0; i < vm.columns.length; i++) {
          const btn1 = 'btn1_' + vm.columns[i].code
          vm.columns[i].btn1Show = obj1[btn1]
        }
      } else {
        return
      }

      if (localStorage.getItem('Student_tutorsSearchBtn2')) {
        let getjson2 = localStorage.getItem('Student_tutorsSearchBtn2')
        let obj2 = JSON.parse(getjson2)

        for (let i = 0; i < vm.columns.length; i++) {
          const btn2 = 'btn2_' + vm.columns[i].code
          vm.columns[i].btn2Show = obj2[btn2]
        }
      } else {
        return
      }

      if (localStorage.getItem('Student_tutorsSearchBtn3')) {
        let getjson3 = localStorage.getItem('Student_tutorsSearchBtn3')
        let obj3 = JSON.parse(getjson3)

        for (let i = 0; i < vm.columns.length; i++) {
          const btn3 = 'btn3_' + vm.columns[i].code
          vm.columns[i].btn3Show = obj3[btn3]
        }
      } else {
        return
      }

      if (localStorage.getItem('Student_tutorsSearchBtn4')) {
        let getjson4 = localStorage.getItem('Student_tutorsSearchBtn4')
        let obj4 = JSON.parse(getjson4)

        for (let i = 0; i < vm.columns.length; i++) {
          const btn4 = 'btn4_' + vm.columns[i].code
          vm.columns[i].btn4Show = obj4[btn4]
        }
      } else {
        return
      }

      if (localStorage.getItem('Student_tutorsSearchBtn5')) {
        let getjson5 = localStorage.getItem('Student_tutorsSearchBtn5')
        let obj5 = JSON.parse(getjson5)

        for (let i = 0; i < vm.columns.length; i++) {
          const btn5 = 'btn5_' + vm.columns[i].code
          vm.columns[i].btn5Show = obj5[btn5]
        }
      } else {
        return
      }

      // // console.log(obj)
      // vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // // alert('save')
    let arr = []
    let obj = {}

    for (let i = 0; i < this.columns.length; i++) {
      const column = 'column_' + this.columns[i].code
      obj[column] = this.columns[i].show
    }

    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('Student_tutorsSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */
.link {
  &:hover {
    background: #0099e8;
  }
}
.m-label-custom {
  width: 17%;
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}

.orange {
  background: #FF9100;
  color: #fff;
}

.red {
  background: #FF1744;
  color: #fff;
}

.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 255px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f2bd";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>

<style lang="scss">
.Student_tutorsIndex {
  .multiselect {
    min-height: 23px;
    /* min-width: 100px; */
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 3px 1px 1px 1px;
  }
  .multiselect__tags-wrap {
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// Student_tutorsIndex.vue?07901d7d